import moment from "moment";
import { endOf, standardDate, startOf, today } from "../manager/dateManager";

export const isPO = (item) => {
  if (item.PO_Status) {
    if (item.PO_Status.includes("NOT RECEIVED")) {
      return true;
    }
  } else {
    return true;
  }
};

export const isPartialPO = (item) => {
  if (
    item.PO_Status &&
    (item.PO_Status.includes("PARTIALLY RECEIVED") ||
      item.PO_Status.includes("FULLY RECEIVED, QC PENDING")) && (parseInt(item.PendingQTY) > 0)
  ) {
    return true;
  } else return false;
};

export const isPOHavingDueThisWeek = (item) => {
  const so = startOf("week");
  const eo = endOf("week");
  if (moment(standardDate(item.duedate)).isBetween(so, eo, undefined, "[]")) {
    return true;
  } else return false;
};

export const isPOFullyReceived = (item) => {
  if (item.PO_Status && item.PO_Status.includes("FULLY RECEIVED")) {
    return true;
  } else return false;
};

export const isCompletedOrder = (item) => {
  if (
    (item.PO_Status &&
      item.PO_Status.includes("FULLY RECEIVED") &&
      item.LatestAction === "Completed") ||
   item.PendingQTY === "0"
  ) {
    return true;
  } else return false;
};

export const isOverDue = (item) => {
  if (moment(standardDate(item.duedate)).isBefore(today())) {
    return true;
  } else return false;
};

export const localStorageItem = () => {
  const localItem = localStorage.getItem("purchaseOrders");
  if (localItem) {
    return localItem;
  } else {
    localStorage.setItem("purchaseOrder", "Purchase Orders");
    return "Purchase Orders";
  }
};
